import { render, staticRenderFns } from "./household.vue?vue&type=template&id=48e259d6&"
import script from "./household.vue?vue&type=script&lang=js&"
export * from "./household.vue?vue&type=script&lang=js&"
import style0 from "./household.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports